import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import Pagination from '../../model/pagination';
import UserModel from '../../model/user.model';
import {environment} from '../../environments/environment';
import QueryEncoder from '../queryEncoder';
import NoteModel from '../../model/note.model';
import {catchError, switchMap} from 'rxjs/operators';

@Injectable()
export default class NoteService {
  public constructor(private http: HttpClient) {
  }

  public list(query?: string, page?: number, limit?: number, sort?: string, direction?: string, additionalInfo?: any): Observable<Pagination<NoteModel>> {
    query = query || '';
    page = page || 1;
    limit = limit || 15;
    sort = sort || '';

    let sorting = {};
    sorting[sort] = direction;

    let q = {query, page, limit, sorting};

    if(additionalInfo) {
      Object.assign(q, additionalInfo);
    }

    return this.http
      .get<Pagination<NoteModel>>(environment.apiUrl + '/notes?' + QueryEncoder.encodeURI(q));
  }

  public create(note: NoteModel): Observable<NoteModel> {
    return this.http
      .post<NoteModel>(environment.apiUrl + '/notes', note);
  }

  public update(note: NoteModel): Observable<NoteModel> {
    return this.http.put<NoteModel>(environment.apiUrl + '/notes/' + note.id, note);
  }

  public delete(note: NoteModel): Observable<boolean> {
    return this.http.delete(environment.apiUrl + '/notes/' + note.id).pipe(
      switchMap(result => of(true)),
      catchError(result => of(false))
    );
  }
}
